<template>
<transition name="modal">
  <div class="modal-mask user-role-confirmation-modal" @click.self="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <h3>登録内容確認</h3>
        <p><strong>以下の内容を登録してよろしいですか？</strong></p>
        <table class="table">
          <tbody>
            <tr><th>社員番号</th><td>{{ employee }}</td></tr>
            <tr><th>氏名</th><td>{{ user }}</td></tr>
            <tr><th>電話番号</th><td>{{ tel }}</td></tr>
            <tr><th>住所</th><td>{{ live }}</td></tr>
            <tr><th>ログインE-Mail</th><td>{{ mail }}</td></tr>
            <tr><th>初期パスワード</th><td>{{ pass }}</td></tr>
            <tr><th>所属部署</th><td>{{ department_name }}</td></tr>
            <tr><th>入社年月日</th><td>{{ formatDate(hire_date) }}</td></tr>
            <tr><th>初期の権限グループ</th><td>{{ roleLabel }}</td></tr>
            <tr><th>申請承認者</th><td>{{ approver_flg ? '有' : '無' }}</td></tr>
            <tr><th>勤怠管理の対象</th><td>{{ attendance_exempt_flg ? '対象外' : '対象' }}</td></tr>
            <tr><th>週稼働日数（有休付与区分）</th><td>{{ workingDaysLabel }}</td></tr>
            <tr><th>有給日数</th><td>{{ unitValue(paid, '日') }}</td></tr>
            <tr><th>代休日数</th><td>{{ unitValue(comp, '日') }}</td></tr>
            <tr><th>今期有休消化日数</th><td>{{ unitValue(paid_used, '日') }}</td></tr>
            <tr><th>有給付与月</th><td>{{ unitValue(paid_add, '月') }}</td></tr>
            <tr><th>固定内残業</th><td>{{ fixed_over_time }}</td></tr>
            <tr><th>SlackメンバーID</th><td>{{ slack_id }}</td></tr>
          </tbody>
        </table>
        <ActionResultMessage :text="error" type="danger" />
        <div class="modal-actions">
          <button @click="$emit('close')" :disabled="loading" class="btn btn-secondary btn-sm">キャンセル</button>
          <save-button
            :label="'登録'"
            :loading="loading"
            :disabled="authorized"
            @click="$emit('register')"
            class="btn btn-info"
          />
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
import ActionResultMessage from '../components/ActionResultMessage.vue'

export default {
  name: 'RegisterModal',
  components: { SaveButton, ActionResultMessage },
  props: {
    employee: String,
    user: String,
    tel: String,
    live: String,
    mail: String,
    pass: String,
    hire_date: String,
    department_name: String,
    role_names: { type: Array, default: () => [] },
    approver_flg: Boolean,
    attendance_exempt_flg: Boolean,
    working_days: Number,
    paid: [String, Number],
    comp: [String, Number],
    paid_used: [String, Number],
    paid_add: [String, Number],
    fixed_over_time: String,
    slack_id: String,
    authorized: Boolean,
    loading: Boolean,
    // 登録を断られた理由。小窓を閉じずにここへ出す。
    error: { type: String, default: '' }
  },
  computed: {
    roleLabel () {
      return this.role_names.length ? this.role_names.join('、') : '一般社員'
    },
    workingDaysLabel () {
      if (this.working_days === 5) return '通常(週5日)'
      if (this.working_days === 0) return '有休付与無し'
      return this.working_days == null ? '' : `週${this.working_days}日`
    }
  },
  methods: {
    formatDate (dateStr) {
      if (!dateStr) return ''
      const [yyyy, mm, dd] = dateStr.split('-')
      return `${yyyy}/${mm}/${dd}`
    },
    unitValue (value, unit) {
      return value === '' || value == null ? '' : `${value}${unit}`
    }
  }
}
</script>

<style scoped>
.modal-mask { position: fixed; z-index: 9998; inset: 0; background-color: rgba(80, 80, 80, .5); display: table; width: 100%; height: 100%; }
.modal-wrapper { display: table-cell; vertical-align: middle; }
.modal-container { width: min(92vw, 640px); max-height: 88vh; overflow-y: auto; margin: 0 auto; padding: 24px 30px; background: #fff; border-radius: 14px; box-shadow: 0 2px 18px rgba(0, 0, 0, .25); }
th { width: 38%; color: #334155; }
td { word-break: break-word; overflow-wrap: anywhere; }
.modal-actions { display: flex; justify-content: space-between; gap: 12px; }
</style>
